import { useEffect, useState } from 'react';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_STATISTICAL } from '../../../shared/constants/app';
import { getMAJAD050, getMAJAD050Resume, getMAJAD050Ticket } from '../../../services/Api';
import moment from 'moment';
import StatisTable from '../../../shared/components/StatisTable';
import { formatNumberWithCommas } from '../../../utils';
const MAJAD050 = () => {
    const [statisDay, setStatisDay] = useState();
    const [statisMonth, setStatisMonth] = useState();
    const [statisDayTicket, setStatisDayTicket] = useState();
    const [statisMonthTicket, setStatisMonthTicket] = useState();
    const [statisResume, setStatisResume] = useState();
    const year = moment().format('YYYY');
    const month = moment().format('MM');
    const day = moment().format('DD');

    const formatData = (data) => {
        let formattedData = {};

        if (data && Array.isArray(data)) {
            data.forEach((item) => {
                const goodNameCode = item.goodNameCode;
                formattedData[`totalCount${goodNameCode}`] = item.totalCount;
                formattedData[`usedCount${goodNameCode}`] = item.usedCount;
                formattedData[`unusedCount${goodNameCode}`] = item.unusedCount;
                formattedData[`totalAmount${goodNameCode}`] = item.totalAmount;
            });
        }

        return formattedData;
    };

    useEffect(() => {
        Promise.all([getMAJAD050(year, month, day), getMAJAD050(year, month, 0)])
            .then(([dayData, monthData]) => {
                setStatisDay(dayData.data);
                setStatisMonth(monthData.data);
            })
            .catch((error) => {
                console.error(error);
            });

        Promise.all([getMAJAD050Ticket(year, month, day), getMAJAD050Ticket(year, month, 0)])
            .then(([dayTicketData, monthTicketData]) => {
                setStatisDayTicket(formatData(dayTicketData.data));
                setStatisMonthTicket(formatData(monthTicketData.data));
            })
            .catch((error) => {
                console.error(error);
            });

        getMAJAD050Resume()
            .then(({ data }) => {
                setStatisResume(data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [year, month, day]);
    return (
        <>
            <div className="container-fluid container statis-page statis-sale">
                <div className="content wrap">
                    <SideMenu menu={MENU_STATISTICAL} />
                    <div className="content-right" style={{ marginTop: 20 }}>
                        <div className="title">4월 덴탈잡 매출현황</div>
                        <div className="group-table">
                            <div className="group-child-table">
                                <div className="child-title" style={{ textAlign: 'end' }}>
                                    마감일 : {year}-{month}-{day}
                                </div>
                                <table className="table table-gray">
                                    <colgroup>
                                        <col width={50} />
                                        <col width={100} />
                                        <col width={150} />
                                        <col width={80} />
                                        <col width={80} />
                                        <col width={80} />
                                        <col width={200} />
                                        <col width={80} />
                                        <col width={80} />
                                        <col width={80} />
                                        <col width={80} />
                                        <col width={200} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th rowSpan={2} colSpan={3}>
                                                구분
                                            </th>
                                            <th colSpan={4}>매출</th>
                                            <td style={{ textAlign: 'center' }} colSpan={5}>
                                                덴탈잡 이용권
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Total</th>
                                            <th>job</th>
                                            <th>mall</th>
                                            <th>금액</th>

                                            <th>총 구매함</th>
                                            <th>
                                                DV Point
                                                <br /> Shop 구매
                                            </th>
                                            <th>사용</th>
                                            <th>미사용</th>
                                            <td style={{ textAlign: 'center' }}>미사용 금액</td>
                                        </tr>
                                        {/* 일계 */}
                                        <tr>
                                            <th rowSpan={19}>일계</th>
                                        </tr>
                                        <tr>
                                            <th colSpan={2}>DVMall 교환 사은품</th>
                                            <td className="two-line">
                                                <div>&nbsp;</div>
                                                <div>14</div>
                                            </td>
                                            <td colSpan={2} className="two-line">
                                                <div>Coffee</div>
                                                <div>9</div>
                                            </td>
                                            <td className="two-line">
                                                <div>Mask(a0/ w5)</div>
                                                <div>5</div>
                                            </td>
                                            <td colSpan={5}></td>
                                        </tr>

                                        {/* statis by day */}
                                        <StatisTable statis={statisDay} statisTicket={statisDayTicket} />

                                        {/* 월계 */}
                                        <tr>
                                            <th rowSpan={19}>월계</th>
                                        </tr>
                                        <tr>
                                            <th colSpan={2}>DVmall 교환 사은품</th>
                                            <td className="two-line">
                                                <div>&nbsp;</div>
                                                <div>245</div>
                                            </td>
                                            <td colSpan={2} className="two-line">
                                                <div>Coffee</div>
                                                <div>151</div>
                                            </td>
                                            <td className="two-line">
                                                <div>Mask(a14/ w80)</div>
                                                <div>94</div>
                                            </td>
                                            <td colSpan={5}></td>
                                        </tr>

                                        {/* statis by month */}
                                        <StatisTable statis={statisMonth} statisTicket={statisMonthTicket} />

                                        {/* 연계 */}
                                        <tr>
                                            <th>연계</th>
                                            <th colSpan={2}>2025년도 106일 누적 매출</th>
                                            <td colSpan={4}>-</td>
                                            <th colSpan={3}>2025년 일평균 매출</th>
                                            <td colSpan={2}>-</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={7}></td>
                                            <th colSpan={3}>2024년 일평균 매출</th>
                                            <td colSpan={2}>-</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="group-table" style={{ marginTop: 20 }}>
                            <div className="group-child-table">
                                <table className="table table-gray">
                                    <colgroup>
                                        <col width={300} />
                                        <col width={240} />
                                        <col width={200} />
                                        <col width={240} />
                                        <col width={280} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>디자인서비스 상품 구매현황</th>
                                            <th>일계</th>
                                            <td style={{ textAlign: 'center' }}>0</td>
                                            <th>월계</th>
                                            <td style={{ textAlign: 'center' }}>5</td>
                                        </tr>
                                        <tr>
                                            <th>디자인서비스 상품 구매 치과명</th>
                                            <td colSpan={4}></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="group-table" style={{ marginTop: 20 }}>
                            <div className="group-child-table">
                                <table className="table table-gray">
                                    <colgroup>
                                        <col width={300} />
                                        <col width={440} />
                                        <col width={520} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>구분</th>
                                            <th>일계</th>
                                            <td style={{ textAlign: 'center' }}>등록된 이력서 총계</td>
                                        </tr>
                                        <tr>
                                            <th>이력서 등록 현황</th>
                                            <td style={{ textAlign: 'center' }}>
                                                {formatNumberWithCommas(statisResume?.todayResume || 0)}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {formatNumberWithCommas(statisResume?.totalResume || 0)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="child-title" style={{ marginTop: 20 }}>
                            ※ 결제기준 현황이며 (V.A.T별도), 마감은 전일 00:00~24:00 입니다.
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default MAJAD050;
